import React from 'react';
import { getPercentagesData } from '../../helpers/boh_spotlights';
import BottomBar from '../../../components/BottomBar';
import SpotlightHeader from '../../Common/Header';
import Goal from './Goal';
import './LoyaltyGauge.scss';
const LoyaltyGauge = props => {
  const {
    metadata,
    text,
    playing,
    bohStyle,
    data
  } = props;
  const {
    boh_goals
  } = metadata;
  const {
    accent_color,
    body_color,
    text_accent_color,
    body_font_family,
    containerStyle
  } = bohStyle;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const {
    percentage,
    goal
  } = getPercentagesData(boh_goals, data);
  return /*#__PURE__*/React.createElement("div", {
    className: "loyalty-gauge",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    showUpdatedTime: true
  }), /*#__PURE__*/React.createElement(Goal, {
    goal: goal,
    percentage: playing ? percentage : 0,
    goal_description: "GOAL",
    body_font_family: body_font_family,
    body_color: body_color,
    playing: playing
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default LoyaltyGauge;